import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from "../context/LanguagesContext";
import { Loader } from './components/Loader'
import { Toaster } from './components/Toaster'
//import { Link } from 'react-router-dom'

import { DropdownButton, Dropdown, Container, Button } from 'react-bootstrap'; // Button
//import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt,
//import EditableSpan from "./components/EditableSpan";
import { LessonCard } from './lessons/LessonCard';

import './css/ContentPages.css';
import { PermissionBlock } from './client-details/PermissionBlock';
import { NewFormBlock } from './components/NewFormBlock';
import { getFileNameFromPath } from './components/tools';

const pluralizeHours = (hours) => hours > 1 ? `${hours} hours` : `${hours} hour`;

export const ClientDetailPage = () => {
    const { request, loading, error } = useHttp()
    const [receivedError, setReceivedError] = useState(error)

    const { token, client, role } = useContext(AuthContext)
    const { activeLanguage, pageLanguage, getCurrentLanguage } = useContext(LanguagesContext); //pageLanguage

    const [clientLessons, setClientLessons] = useState([])
    const [clientNotifications, setClientNotifications] = useState({})
    const [dropdownLessons, setDropdownLessons] = useState([])

    const [clientData, setClientData] = useState()

    const history = useHistory();

    let paramId = useParams().id;
    let clientId = (role === 'admin' ? paramId : client);

    const fetchClient = useCallback(async () => {
        try {
            let path = `/client/${clientId}`

            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })

            if (fetched.client) {
                console.log('get client data', fetched.client);
                setClientData(fetched.client);
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, clientId, role])

    const fetchClientLessons = useCallback(async () => {

        let path = `/client/${clientId}/lessons`

        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })

            console.log('client_lessons', fetched);
            let clientLessons = fetched?.length ? fetched : [];
            setClientLessons(clientLessons)

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, clientId, role])

    const fetchClientNotifications = useCallback(async () => {

        let path = `/client/${clientId}/notifications`

        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })

            setClientNotifications(fetched.reduce((acc, item) => ({
                ...acc,
                [item.notification_type]: item,
            }), {}))

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, clientId])

    const fetchDropdownLessons = useCallback(async () => {
        try {
            const fetched = await request('/lesson/all', 'GET', null, {
                'x-access-token': token
            })
            if (fetched.lessons) {
                console.log('dropdown_lessons', fetched.lessons);
                let dropdownFiltered = fetched.lessons.filter(
                    l => !clientLessons.some(cl => cl.id === l.id));
                setDropdownLessons(dropdownFiltered)
            }

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, clientLessons])

    /// STARTUP

    useEffect(() => {
        fetchClient()
        if (role === 'admin')
            fetchDropdownLessons();
    }, [fetchClient, role])

    useEffect(() => {
        fetchClientLessons()
        fetchClientNotifications()
    }, [fetchClientLessons])


    /// HANDLERS

    const addLessonToClient = async (lesson) => {
        try {
            const data = await request(`/client/${clientId}/link/${lesson.id}`, 'GET', null, {
                'x-access-token': token
            })

            if (data.changed > 0) {
                setClientLessons(clientLessons => [...clientLessons, lesson])
                setDropdownLessons(dropdownLessons => dropdownLessons.filter(item => item.id !== lesson.id))
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteLessonFromClient = async (lessonId) => {
        try {
            let clientId = clientData.id;
            let lesson = clientLessons.find(item => item.id === lessonId);

            if (!lesson) return;

            const data = await request(`/client/${clientId}/unlink/${lesson.id}`, 'GET', null, {
                'x-access-token': token
            })
            // 

            if (data.changed > 0) {
                setDropdownLessons(dropdown_lessons => [...dropdown_lessons, lesson])
                setClientLessons(client_lessons => client_lessons.filter(item => item.id !== lesson.id))
            }
            else
                console.log('lesson link not changed');

        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeLessonIndex = async () => { }  // TODO

    const updateLesson = (lesson) => {
        setClientLessons(client_lessons => client_lessons.map(
            item => item.id === lesson.id ? lesson : item
        ))
    };

    const actionLogoFile = useCallback(async (action, imageFile) => {
        try {
            let data

            if (action === 'upload') {

                const form_data = new FormData()
                form_data.append('image', imageFile, imageFile.name)

                data = await request(`/client/${clientId}/upload/logo`, 'POST', form_data, {
                    'x-access-token': token,
                    'Content-Type': 'multipart/form-data'
                }, true)

                if (!data.error)
                    setClientData(client => { return { ...client, logo: data.logo } });

            } else {
                data = await request(`/client/${clientId}/remove/logo/${getFileNameFromPath(imageFile)}`, 'GET', null, {
                    'x-access-token': token
                })

                if (!data?.error)
                    setClientData(client => { return { ...client, logo: null } });
            }

        } catch (e) {
            setReceivedError(e)
        }
    }, [error, request, token]);

    const changeClientPublicName = async (value) => {

        try {
            const data = await request(`/client/${clientId}/update/public_name`, 'POST', { public_name: value }, {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setClientData(client => { return { ...client, public_name: value } });
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeClientNotifications = async (notificationType, valueType, value) => {
        const name = value[`name_${value.language}`];

        if (valueType === 'delay' && isNaN(name)) {
            setReceivedError([{ message: 'Delay value must be a number' }]);
            return;
        }

        try {
            await request(`/client/${clientId}/notifications`, 'PUT', {
                [notificationType]: {
                    [valueType]: name,
                },
            }, {
                'x-access-token': token
            });

            fetchClientNotifications();
        } catch (e) {
            setReceivedError(e)
        }
    };

    return (
        <Container fluid>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            {loading && <Loader />}

            <h3 className="FormTitle">
                {role === "admin" ? <Button onClick={() => {
                    history.goBack();
                }} variant="light" className='mr-2'>{"< "}</Button> : null}
                Content settings {role === "admin" && clientData ? "(" + clientData.name + ")" : null}</h3>

            {(role === 'admin' && dropdownLessons && dropdownLessons.length)
                ?
                <div>
                    <h3 className="FormSubTitle">Add Lesson</h3>
                    <DropdownButton id="dropdown-basic-button" variant="info" title="Select"
                        className="mr-2 BoxShadowSelect FormText">
                        {dropdownLessons.map((lesson, index) =>
                            <Dropdown.Item key={lesson.id} onClick={() => addLessonToClient(lesson)}
                                className="FormTextDark BoxShadow">
                                {activeLanguage.filter(lang => lesson["name_" + lang.code])
                                    .map(lang => lesson["name_" + lang.code]).join("|")}
                            </Dropdown.Item>
                        )}
                    </DropdownButton>
                </div>
                : (clientLessons && clientLessons.length ? <span /> :
                    <span className="mr-2 FormText">No Available Lessons</span>)
            }

            <br />
            {(clientLessons && clientLessons.length)
                ?
                <div>
                    <h3 className="FormSubTitle">Lessons List</h3>
                    <div className="ml-2">
                        {clientLessons.map((lesson, index, array) => {  //, index, array
                            return (
                                <LessonCard
                                    editableTable={false}
                                    key={lesson.id} index={index} lesson={lesson} array={array}
                                    pageLanguage={pageLanguage} activeLanguage={activeLanguage}

                                    changeLessonIndex={role === 'admin' ? changeLessonIndex : null}
                                    deleteLesson={role === 'admin' ? deleteLessonFromClient : null}
                                    updateLesson={updateLesson}

                                    activeLineEnabled={true}
                                    setReceivedError={setReceivedError}
                                    showAllLanguages={true}
                                />
                            )
                        }
                        )}
                    </div>
                </div>
                : <span className="ml-2 text-white">No added lessons</span>}

            {clientData &&
                <PermissionBlock clientData={clientData} />
            }
            <div>
                <h3 className="mt-5 FormTitle">Company Settings</h3>
                <table className="w-100">
                    <colgroup>
                        <col width={400} />
                        <col />
                    </colgroup>
                    <tr><td>
                        <p className="FormText">Logo:</p></td><td>
                            {
                                clientData?.logo ? <div>
                                    <img src={process.env.REACT_APP_API + clientData?.logo} alt="logo" width="100" height="50" className='m-3' />
                                    <img
                                        src="/img/TrashB.png"
                                        onClick={() => {
                                            if (window.confirm("Delete this logo?")) {
                                                actionLogoFile(
                                                    "delete",
                                                    clientData.logo
                                                );
                                            }
                                        }}
                                        className="text-danger mx-4 TableSecondLineImg"
                                        alt=""
                                    /></div> :
                                    <div><img src="/none.jpg" alt="no-logo" width="100" height="50" className='m-3 text-white' />
                                        <label htmlFor="company_logo_file">
                                            <input
                                                type="file"
                                                id="company_logo_file"
                                                name="company_logo_file"
                                                style={{ display: "none" }}
                                                onChange={(e) => {
                                                    if (window.confirm("Upload this file?")) {
                                                        actionLogoFile(
                                                            "upload",
                                                            e.target.files[0]
                                                        );
                                                    }
                                                }}
                                            />
                                            <img src="/img/Upload.png"
                                                className="TableSecondLineImg"
                                                alt="Upload new file"
                                            />
                                            <span className="TableSecondLineText mx-2">Select file..</span>
                                        </label>
                                    </div>
                            }</td>
                    </tr>
                    <tr><td><h4 className="FormSubTitle">App Notification Text</h4></td></tr>
                    <tr>
                        <td><p className="FormText mr-2">The user has not completed tasks for a long time:</p></td>
                        <td className='d-flex align-items-center'>
                            <div className="w-100">
                                <div className="FormText mb-2">{clientNotifications?.inactivity?.notification_text ?? '-'}</div>
                                <NewFormBlock
                                    languageData={getCurrentLanguage()}
                                    addAction={v => changeClientNotifications('inactivity', 'notification_text', v)}
                                    loadingState={loading}
                                    buttonLabel={'Save'}
                                    placeholderText={"Enter message..."}
                                />
                            </div>
                        </td>
                        <td className='d-flex align-items-center'>
                            <NewFormBlock
                                languageData={getCurrentLanguage()}
                                addAction={v => changeClientNotifications('inactivity', 'delay', v)}
                                loadingState={loading}
                                buttonLabel={'Save delay time'}
                                placeholderText={"24"}
                                syfix={clientNotifications?.inactivity?.delay ? pluralizeHours(clientNotifications.inactivity.delay) : '0 hours'}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><p className="FormText mr-2">The user forgot to perform the scheduled action:</p></td>
                        <td className='d-flex align-items-center'>
                            <div className="w-100">
                                <div className="FormText mb-2">{clientNotifications?.scheduled_action?.notification_text ?? '-'}</div>
                                <NewFormBlock
                                    languageData={getCurrentLanguage()}
                                    addAction={a => changeClientNotifications('scheduled_action', 'notification_text', a)}
                                    loadingState={loading}
                                    buttonLabel={'Save'}
                                    placeholderText={"Enter message..."}
                                />
                            </div>
                        </td>
                        <td className='d-flex align-items-center'>
                            <NewFormBlock
                                languageData={getCurrentLanguage()}
                                addAction={a => changeClientNotifications('scheduled_action', 'delay', a)}
                                loadingState={loading}
                                buttonLabel={'Save delay time'}
                                placeholderText={"24"}
                                syfix={clientNotifications?.scheduled_action?.delay ? pluralizeHours(clientNotifications.scheduled_action.delay) : '0 hours'}
                            />
                        </td>
                    </tr>
                    {/*<tr><td><h4 className="FormSubTitle">Emails Text</h4></td></tr>
                    <tr><td><span className='text-white small'>Use ###newpasswordsetuplink### in email template text for password reset link</span></td></tr>
                    <tr>
                        <td><p className="FormText ">Activation email and setting a new password:</p></td>
                        <td className='d-flex align-items-center'>
                            <NewFormBlock languageData={getCurrentLanguage()} addAction={() => { }} loadingState={loading} buttonLabel={'Save'} placeholderText={"Enter email text.."} />
                        </td>
                    </tr>
                    <tr>
                        <td><p className="FormText ">Email about forgotten password and its reset:</p></td>
                        <td className='d-flex align-items-center'>
                            <NewFormBlock languageData={getCurrentLanguage()} addAction={() => { }} loadingState={loading} buttonLabel={'Save'} placeholderText={"Enter email text.."} />
                        </td>
                    </tr>*/}
                </table>
            </div >

        </Container >
    )
}
